<template>
    <ProcColumnPanel
        title="Formulários"
        :subtitle="`${resumo.qtd_doc_pendente || 0} pendente(s)`"
        :expanded="expanded"
        @toggle-expand="$emit('toggle-expand')"
    >
        <div v-if="formularios.length === 0" class="empty-box">
            Nenhum formulário configurado para esta etapa.
        </div>

        <div
            v-for="doc in formularios"
            :key="`${doc.idepdocmodelo}-${doc.iddoc || 'novo'}`"
            class="proc-card"
        >
            <div class="card-main">
                <div class="card-text">
                    <h4>{{ doc.nmepdocmodelo }}</h4>
                    <p v-if="doc.informacoes">{{ doc.informacoes }}</p>
                </div>

                <span :class="['status-pill', statusDocClasse(doc)]">
                    {{ statusDocTexto(doc) }}
                </span>
            </div>

            <div class="tag-row">
                <span v-if="doc.ckobrigatorio === 'S'" class="tag obrigatorio">Obrigatório</span>
                <span v-if="doc.ckexige_assinatura === 'S'" class="tag">Assinatura</span>
                <span v-if="doc.ckgera_anexo_pdf === 'S'" class="tag">PDF</span>
                <span v-if="doc.ckpermite_multiplos === 'S'" class="tag">Múltiplos</span>
            </div>

            <div class="card-actions">
                <button
                    v-if="podeInserirDados && !doc.idlaudo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('editar', doc)"
                >
                    {{ doc.iddoc ? 'Editar' : 'Iniciar' }}
                </button>

                <button
                    v-if="doc.idlaudo"
                    class="btn-small proc-btn"
                    type="button"
                    @click="$emit('visualizar-anexo', doc.idlaudo)"
                >
                    Laudo
                </button>

                <button
                    v-if="doc.iddoc"
                    class="btn-small proc-btn danger"
                    type="button"
                    @click="$emit('cancelar', doc)"
                >
                    Cancelar
                </button>
            </div>
        </div>
    </ProcColumnPanel>
</template>

<script setup>
import ProcColumnPanel from './ProcColumnPanel.vue';

defineProps({
    formularios: { type: Array, default: () => [] },
    resumo: { type: Object, required: true },
    podeInserirDados: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    statusDocTexto: { type: Function, required: true },
    statusDocClasse: { type: Function, required: true },
});

defineEmits(['editar', 'cancelar', 'visualizar-anexo', 'toggle-expand']);
</script>
